export class TimerCommand {
    static start = 'start';
    static stop = 'stop';
}

export const consoleTimer = (timeName) => {
    let running = false;

    return (timerCommand) => {
        if (timerCommand === TimerCommand.stop && running === true) {
            console.timeEnd(timeName);
            running = false;

        } else if (timerCommand === TimerCommand.start && running !== true) {
            running = true;
            console.time(timeName);
        }
    };
};
